'use client';

// import { Markup } from "@/sections/markup/Markup"
// import { textBlock } from "@/uiPrimitives/typography/text"
import { TermsAndConditionsCheckboxField } from '../ContactForm.types';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { shelf } from '@/uiPrimitives/layout/shelf';
import { checkboxCSS } from '@/uiComposites/form/checkbox.css';
import { useFieldState } from '../helpers/useFieldState';
import { box } from '@/uiPrimitives/layout/box';
import { stack } from '@/uiPrimitives/layout/stack';
import { FieldIssue } from '../FieldIssue';
import { useInputProps } from '../helpers/useInputProps';
import { textBlock } from '@/uiPrimitives/typography/text';
import { ReactNode } from 'react';
import { occupy } from '@/uiPrimitives/layout/occupy';
import { indentSize } from '@/uiPrimitives/layout/indentSize.definitions';
import { addTestSelector } from '@dop/shared/helpers/testSelector';
import { hidden } from '@/uiPrimitives/utility/display.css';

export const TermsAndConditionsCheckboxFormField = ({
	id,
	children,
	...field
}: TermsAndConditionsCheckboxField & { id: string; children: ReactNode }) => {
	const { name, value, required, nothingChosenErrorMessage = '' } = field;
	const inputProps = useInputProps(field);
	const {
		isDirty,
		isTouched,
		isValid,
		issue,
		value: currentValue,
	} = useFieldState(name);

	const showEmptyError =
		isDirty && isTouched && !isValid && issue === nothingChosenErrorMessage;
	const emptyErrorId = `error-${name}-empty`;

	return (
		<div
			id={`form:${name}`}
			className={classes(
				stack({ rowGap: showEmptyError ? '2 | h2' : undefined }),
			)}
		>
			<label className={classes(shelf({}))} htmlFor={id}>
				<span
					className={classes(
						occupy({
							blockSize: 'capSize',
							inlineSize: indentSize,
							justifyItems: 'start',
						}),
					)}
				>
					<input
						type="checkbox"
						aria-invalid={isDirty && !isValid}
						aria-describedby={showEmptyError ? emptyErrorId : undefined}
						className={classes(
							checkboxCSS,
							showEmptyError && box({ borderColor: 'positiveRed' }),
						)}
						aria-required={required}
						name={name}
						id={id}
						value={value}
						checked={value === currentValue}
						{...inputProps}
						{...addTestSelector('uiVoorwaardenCheckbox')}
					/>
				</span>
				<span className={classes(textBlock({}))}>{children}</span>
			</label>
			<FieldIssue id={emptyErrorId} hiddenClassName={!showEmptyError && hidden}>
				{nothingChosenErrorMessage}
			</FieldIssue>
		</div>
	);
};
